module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-27.51f3ff78.png";